import React from "react";

// Import Ionic
import { IonLabel } from "@ionic/react";

// Import Styles
import styles from "./ProductDetailInStock.module.scss";
import classNames from "classnames/bind";
import { Product } from "@core/types";
import { useTranslation } from "react-i18next";
import { useConfig } from "../../../providers/config";

interface IProductDetailInStock {
  isInStock: boolean;
  label?: string;
  stockQuantity: Product["stockQuantity"];
  portionUnit: Product["portionUnit"];
}

const cx = classNames.bind(styles);

const ProductDetailInStock: React.FC<IProductDetailInStock> = ({
  isInStock = false,
  label,
  stockQuantity,
  portionUnit,
}) => {
  const { t } = useTranslation();
  const { minLowStockThresholdToShowNumber, showStockQuantity } = useConfig();

  if (label?.length) {
    return (
      <IonLabel className={cx("stockStatus")} color="danger">
        {label}
      </IonLabel>
    );
  }

  const isProductStockLow =
    showStockQuantity &&
    minLowStockThresholdToShowNumber &&
    stockQuantity &&
    stockQuantity <= minLowStockThresholdToShowNumber;

  return (
    <>
      {isInStock ? (
        <IonLabel className={cx("stockStatus")} color="success">
          {isProductStockLow ? `Осталось ${stockQuantity.toFixed(1)} ${portionUnit}` : t("In Stock")}
        </IonLabel>
      ) : (
        <IonLabel className={cx("stockStatus")} color="danger">
          {t("Out of Stock")}
        </IonLabel>
      )}
    </>
  );
};

export default ProductDetailInStock;
